import React from 'react'
import { Skeleton } from '@mui/material'

import { useToast } from '@hooks'
import { isLoadingCommonFilters } from '@signals'
import { WEBBACK_V2_API } from '@constants'
import { TitleWithPopover, AppTableSeeker } from "@components";
import { dateColumn, skuColumn, sitePriceColumn, priceDiffColumn, priceAbsDiffColumn, winnerColumn } from "./columns";
import { usePricingSideComparisonFilters } from "../@hooks";


export default function PricingSideComparisonTable() {

    const { data, firstRetailer, secondRetailer } = usePricingSideComparisonFilters()
    const { showToast } = useToast()

    if (isLoadingCommonFilters.value) return <Skeleton variant="rectangular" height={500} />
    if (!data.length) return <></>

    const columns = [
        dateColumn(),
        ...skuColumn(),
        sitePriceColumn('firstRetailer', firstRetailer),
        sitePriceColumn('secondRetailer', secondRetailer),
        winnerColumn(),
        priceDiffColumn(),
        priceAbsDiffColumn()
    ]

    return <AppTableSeeker
        data={data}
        title={ <TitleWithPopover title="Side by Side Comparison" />}
        columns={columns}
        options={{
            onDownload: () => showToast.promiseExcel(`${WEBBACK_V2_API}/pricing/side-comparison/excel`),
        }}
    />
}